const phoneRegex = /^(\+?\d{1,3})?[-. ]?\d{3}[-. ]?\d{3}[-. ]?\d{3}$/;

export const isValidPhoneNumber = (phoneNumber: string) => {
  return phoneRegex.test(phoneNumber);
};
